"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dialog = exports.Backdrop = exports.Wrapper = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var react_focus_lock_1 = __importDefault(require("react-focus-lock"));
var Sheet_1 = require("./Sheet");
var Icon_1 = require("./Icon");
var Text_1 = __importDefault(require("./Text"));
var Title_1 = __importDefault(require("./Title"));
var accessors_1 = require("../themes/accessors");
exports.Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 700;\n  width: inherit;\n  outline: 0;\n"], ["\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 700;\n  width: inherit;\n  outline: 0;\n"])));
exports.Backdrop = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  background: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(3px);\n  z-index: 500;\n"], ["\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  background: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(3px);\n  z-index: 500;\n"])));
var Content = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding: 10px;\n  flex: 1;\n  max-height: 30rem;\n  overflow-x: hidden;\n  overflow-y: auto;\n"], ["\n  padding: 10px;\n  flex: 1;\n  max-height: 30rem;\n  overflow-x: hidden;\n  overflow-y: auto;\n"])));
var Buttons = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-evenly;\n  width: 100%;\n"], ["\n  display: flex;\n  justify-content: space-evenly;\n  width: 100%;\n"])));
var DialogContent = styled_components_1.default(Sheet_1.Sheet)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  align-items: center;\n  min-height: 15rem;\n  width: 35rem;\n  padding: 2rem;\n"], ["\n  align-items: center;\n  min-height: 15rem;\n  width: 35rem;\n  padding: 2rem;\n"])));
var Header = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  fill: ", ";\n  text-align: center;\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  fill: ", ";\n  text-align: center;\n"])), accessors_1.textColor('contrast'));
var Dialog = function (_a) {
    var show = _a.show, dismiss = _a.dismiss, title = _a.title, content = _a.content, buttons = _a.buttons, icon = _a.icon;
    var onKeyDown = function (event) {
        if (event.keyCode === 27 && show) {
            dismiss();
        }
    };
    react_1.useEffect(function () {
        show ? (document.body.style.overflow = 'hidden') : (document.body.style.overflow = 'unset');
        document.addEventListener('keydown', onKeyDown, false);
        return function () {
            document.removeEventListener('keydown', onKeyDown, false);
        };
    }, [show]);
    react_1.useEffect(function () { return function () { document.body.style.overflow = 'unset'; }; });
    if (!show)
        return null;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(exports.Backdrop, { onClick: dismiss }),
        react_1.default.createElement(react_focus_lock_1.default, null,
            react_1.default.createElement(exports.Wrapper, { "aria-modal": true, "aria-labelledby": title, tabIndex: -1, role: "dialog" },
                react_1.default.createElement(DialogContent, null,
                    react_1.default.createElement(Header, null,
                        react_1.default.createElement(Icon_1.Icon, { name: icon, size: "lg" }),
                        react_1.default.createElement(Title_1.default, { level: 1, title: title })),
                    react_1.default.createElement(Content, null, typeof content === 'string' ? react_1.default.createElement(Text_1.default, null, content) : content),
                    react_1.default.createElement(Buttons, null, buttons))))));
};
exports.Dialog = Dialog;
exports.default = exports.Dialog;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
